angular.module('leanlaw').controller('PeriodReportsSidebarCtrl', ['$scope', '$rootScope', 'userService', function ($scope, $rootScope, userService) {
  $scope.custom = {
    startMonth: undefined,
    endMonth: undefined,
    startQuarter: undefined,
    endQuarter: undefined,
    startYear: undefined,
    endYear: undefined
  };
  activate();
  async function activate() {
    $scope.accounts = await userService.list();
    $scope.primaries = [{
      id: 'clients',
      label: 'Clients'
    }, {
      id: 'accounts',
      label: 'Users'
    }];
    const me = await userService.me();
    if (me.company.usesMatterTags) {
      $scope.primaries.push({
        id: 'mattertag',
        label: 'Practice Area'
      });
    }
    $scope.billingTypes = [{
      id: 'include',
      filter: null,
      label: 'Include Internal'
    }, {
      id: 'exclude',
      filter: '-internal',
      label: 'Exclude Internal'
    }, {
      id: 'only',
      filter: 'internal',
      label: 'Only Internal'
    }];
    const hoursDecimal = 'hoursDecimal';
    const amount = 'amount';
    const hoursService = 'hours,services';
    function addProperty(id, label, filter, data) {
      $scope.properties.push({
        id,
        label,
        filter,
        data
      });
    }
    $scope.properties = [];
    addProperty('hours.total', 'Hours Total', hoursDecimal, hoursService);
    addProperty('hours.billable', 'Hours Billable', hoursDecimal, hoursService);
    addProperty('hours.nonBillable', 'Hours Non-Billable', hoursDecimal, hoursService);
    if (me.permissions.reports.revenue) {
      addProperty('collected.servicesTotal', 'Collected Services', amount, 'payments');
      addProperty('collected.expensesTotal', 'Collected Expenses', amount, 'payments');
      addProperty('collected.total', 'Collected Total', amount, 'payments');
    }
    if (me.permissions.reports.billable) {
      addProperty('amounts.expenses', 'Expenses Billable', amount, 'expenses');
      addProperty('invoiced.expenses', 'Expenses Billed', amount, 'invoices');
      addProperty('invoiced.total', 'Billed Total', amount, 'invoices');
      addProperty('invoiced.hours', 'Hours Billed', amount, 'invoices');
      addProperty('amounts.hours', 'Hours Billable Amount', amount, hoursService);
      if (me.adjustments) {
        addProperty('amounts.hourAdjustment', 'Hours Adjustments Amount', hoursDecimal, hoursService);
      }
    }
    if (me.adjustments) {
      addProperty('hours.trackedHours', 'Hours Tracked', hoursDecimal, hoursService);
      addProperty('amounts.trackedHours', 'Hours Tracked Amount', hoursDecimal, hoursService);
      addProperty('hours.hourAdjustment', 'Hours Adjustments', hoursDecimal, hoursService);
    }
    $scope.properties.sort((a, b) => a.label > b.label);
    $scope.years = [];
    for (let i = 0; i < 10; i++) {
      const year = new Date().getFullYear() - i;
      $scope.years.push({
        label: year,
        year
      });
    }
    $scope.months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((label, index) => ({
      label,
      index
    }));
    $scope.quarters = [];
    for (let j = 0; j < 4; j++) {
      const quarter = ["Q1", "Q2", "Q3", "Q4"];
      $scope.quarters.push({
        label: quarter[j],
        index: j
      });
    }
    $scope.customChange = () => {
      // This gets called when we have custom time period selected and any of the values change
      // We convert the custom date to a time period for the filter
      const {
        range
      } = $scope.filter.period;
      const {
        startMonth,
        endMonth,
        startQuarter,
        endQuarter,
        startYear,
        endYear
      } = $scope.custom;
      const {
        timeUnit
      } = $scope.filter;
      if (timeUnit.id === 'months') {
        range.startDate = new Date(startYear.year, startMonth.index, 1);
        range.endDate = new Date(endYear.year, endMonth.index + 1, 0);
      }
      if (timeUnit.id === 'quarter') {
        range.startDate = new Date(startYear.year, startQuarter.index * 3, 1);
        range.endDate = new Date(endYear.year, (endQuarter.index + 1) * 3, 0);
      }
      if (timeUnit.id === 'year') {
        range.startDate = new Date(startYear.year, 0, 1);
        range.endDate = new Date(endYear.year + 1, 0, 0);
      }
    };
    $scope.unitPeriods = [{
      id: 'day',
      label: 'Day',
      period: 'day'
    }, {
      id: 'months',
      label: 'Month',
      period: 'month'
    }, {
      id: 'quarter',
      label: 'Quarter',
      period: 'quarter'
    }, {
      id: 'year',
      label: 'Year',
      period: 'year'
    }];
    $scope.periods = [{
      id: 'ytd',
      label: 'Year-to-Date',
      period: 'month',
      range: {
        startDate: new Date(new Date().getFullYear(), 0, 1),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      }
    }, {
      id: 'lastYear',
      label: 'Last Year',
      period: 'month',
      range: {
        startDate: new Date(new Date().getFullYear() - 1, 0, 1),
        endDate: new Date(new Date().getFullYear(), 0, 0)
      }
    }, {
      id: 'months',
      label: 'Last 12 Months',
      period: 'month',
      range: {
        startDate: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 1),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      }
    }, {
      id: 'thisMonth',
      label: 'This Month',
      period: 'day',
      range: {
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      }
    }, {
      id: 'lastMonth',
      label: 'Last Month',
      period: 'day',
      range: {
        startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0)
      }
    }, {
      id: 'thisYear',
      label: 'This Year',
      period: 'quarter',
      range: {
        startDate: new Date(new Date().getFullYear(), 0, 1),
        endDate: new Date()
      }
    }, {
      id: 'lastYear',
      label: 'Last Year',
      period: 'quarter',
      range: {
        startDate: new Date(new Date().getFullYear() - 1, 0, 1),
        endDate: new Date(new Date().getFullYear(), 0, 0)
      }
    }, {
      id: 'thisAndLastYear',
      label: 'This and last year',
      period: 'quarter',
      range: {
        startDate: new Date(new Date().getFullYear() - 1, 0, 1),
        endDate: new Date(new Date().getFullYear() + 1, 0, 0)
      }
    }, {
      id: 'last3Years',
      label: 'Last 3 years',
      period: 'year',
      range: {
        startDate: new Date(new Date().getFullYear() - 2, 0, 1),
        endDate: new Date(new Date().getFullYear() + 1, 0, 0)
      }
    }, {
      id: 'lastFiveYears',
      label: 'Last 5 years',
      period: 'year',
      range: {
        startDate: new Date(new Date().getFullYear() - 4, 0, 1),
        endDate: new Date(new Date().getFullYear() + 1, 0, 0)
      }
    }];
    $scope.periods.push({
      id: 'custom',
      label: "Custom Period",
      period: 'all',
      custom: true
    });

    // This keeps track of the previous value of filter.period so that if it gets changed to
    // "custom" we will set the time range of custom to what was selected previously
    let previousPeriod;
    $scope.byTimeUnit = function (timeUnit) {
      $scope.periods.find(p => p.period === 'all').range = angular.copy($scope.filter.timeUnit.id === 'year' ? $scope.filter.period.range.startPeriod : $scope.filter.period.range);
      return function (timePeriod) {
        return !timeUnit || timePeriod.period === timeUnit.period || timePeriod.period === 'all';
      };
    };
    $scope.timeUnitChange = filter => {
      $scope.filter.period = $scope.periods.find(p => p.period === filter.period);
      previousPeriod = $scope.filter.period;
    };
    $scope.timePeriodChange = period => {
      // If the time period is custom we need to update the start/end custom periods to the previously 
      // selected time period
      if (period.id !== 'custom') {
        previousPeriod = period;
        return;
      }
      $scope.filter.period.range = previousPeriod.range;
      const {
        startDate,
        endDate
      } = previousPeriod.range;
      const {
        timeUnit
      } = $scope.filter;
      if (timeUnit.id === 'months') {
        $scope.custom.startMonth = $scope.months[startDate.getMonth()];
        $scope.custom.endMonth = $scope.months[endDate.getMonth()];
      }
      if (timeUnit.id === 'quarter') {
        $scope.custom.startQuarter = $scope.quarters[Math.trunc(startDate.getMonth() / 3)];
        $scope.custom.endQuarter = $scope.quarters[Math.trunc(endDate.getMonth() / 3)];
      }
      $scope.custom.startYear = $scope.years.find(yr => yr.label === startDate.getFullYear());
      $scope.custom.endYear = $scope.years.find(yr => yr.label === endDate.getFullYear());

      // This is not really necessary but seems like a good idea to run this so that we are sure
      // that the filter.period object is in sync with the custom selections
      $scope.customChange();
    };
    $scope.filter = {
      primary: $scope.primaries[0],
      property: $scope.properties[0],
      period: $scope.periods.find(p => p.id === 'ytd'),
      timeUnit: $scope.unitPeriods.find(p => p.id === 'months'),
      include: {
        matters: false,
        zeros: false
      },
      billingType: {
        id: 'include'
      }
    };
    $scope.filter.include.matters = false;
    previousPeriod = $scope.filter.period;

    // Fires immediately on filter creation
    $scope.$watch("filter", () => {
      $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
    }, true);
  }
}]);